
import { useContext, useState, useEffect } from 'react';

import AuthContext from '../../store/AuthContext';
import CopyButton from '../widgets/CopyButton';
import * as utils from '../../services/utils';

function AuthCode () {   
  const iuaCtx = useContext(AuthContext);

  const authCodeEmpty = 'No data found';
  const [authCodeResult, setAuthCodeResult] = useState(authCodeEmpty);
  const [displayStyle, setDisplayStyle] = useState({content: 'white-text'});

  useEffect(() => {
    getCode();   
  }, [iuaCtx.authSearchData]);

  function getCode() {
    const searchData = iuaCtx.authSearchData;
    const code = utils.getCodeFromSearchData(searchData);
    if (code) {
      setAuthCodeResult(code);
      setDisplayStyle({
        success: 'success',
        header: 'success',
        content: 'white-text'
      });
      iuaCtx.setAuthCode(code);
      return;
    } 
    const errMsg = utils.getSearchDataText(searchData);
    if (errMsg) {
      setAuthCodeResult(errMsg);
      setDisplayStyle({
        error: 'error',
        header: 'error',
        content: 'error-text'
      });
      iuaCtx.setAuthErr(errMsg);
    }
  }

  return (
    <div className={"card card-body code-block " + displayStyle.header} title="Authorization Code">
      <div className={"main-form-output spc-pb-6 " + displayStyle.content}>
      {displayStyle.success && <span>{authCodeResult}</span>}
      {displayStyle.error && <pre>{authCodeResult}</pre>}
      <CopyButton data={authCodeResult}></CopyButton>
      </div>
    </div>
    );

}

export default AuthCode;